import React from "react";
import Lottie from "react-lottie";

import styles from "./threeSixty.module.scss";

const LOTTIE_OPTIONS = {
  loop: true,
  autoplay: true,
  animationData: require("@/assets/lottie/three-sixty.json"),
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice"
  }
};

const ThreeSixty = props => {
  const { isHovered } = props;

  return (
    <div className={styles.container}>
      <Lottie
        options={LOTTIE_OPTIONS}
        width={105}
        height={130}
        isStopped={isHovered}
      />
    </div>
  );
};

export default ThreeSixty;
